// extracted by mini-css-extract-plugin
module.exports = {"container":"calendar-summary-box_container__GITH-"};